import {
  DELETE_ICON_TOP_OFFSET_LANDSCAPE,
  DELETE_ICON_TOP_OFFSET_PORTRAIT,
  TEXT_BOX_WIDTH_OFFSET_LANDSCAPE,
  TEXT_BOX_WIDTH_OFFSET_PORTRAIT,
} from '../../../constants/user-zone-textbox-offsets';
import { getPanelWidth } from '../../../utils/panel-zoom';

type GetTextAreaWidthProps = {
  cardFormat: string;
  cardFaceType: string;
  canvasWidth: number;
  canvasZoom: number;
  scalingFactor: number;
  isPanelZoom?: boolean;
  isRightPanel?: boolean;
};

export const getDefaultUserTextPosition = ({
  cardFormat,
  cardFaceType,
  canvasWidth,
  canvasZoom,
  scalingFactor,
  isPanelZoom: isPanelZoomProp,
  isRightPanel: isRightPanelProp,
}: GetTextAreaWidthProps) => {
  const isPanelZoom = isPanelZoomProp ?? false;
  const isRightPanel = isRightPanelProp ?? false;

  // Determine card orientation and face type to drive layout decisions
  const isLandscape = cardFormat === 'landscape';
  const isFrontOrBack = cardFaceType === 'front' || cardFaceType === 'back';
  // Landscape and front/back faces span the full canvas width
  const shouldUseWideText = isLandscape || isFrontOrBack;

  // Padding is scaled to match the canvas scaling factor
  const basePadding = 40;
  const padding = basePadding * scalingFactor;
  const totalPadding = 2 * padding; // applied to both left and right sides

  // For split-panel faces, panelWidth represents one panel's width rather than the full canvas
  const panelWidth = getPanelWidth({ isPanelZoom, canvasWidth, canvasZoom });

  // Wide text spans the full canvas; narrow text is constrained to a single panel
  const width = shouldUseWideText
    ? canvasWidth / canvasZoom - totalPadding - TEXT_BOX_WIDTH_OFFSET_LANDSCAPE
    : panelWidth - totalPadding - TEXT_BOX_WIDTH_OFFSET_PORTRAIT;

  const textBoxDefaultHeight = 100;
  const height = textBoxDefaultHeight;

  // Horizontal offsets differ between landscape and portrait orientations
  const landscapeLeftOffset = 65;
  const portraitLeftOffset = 52;

  const top = isLandscape ? DELETE_ICON_TOP_OFFSET_LANDSCAPE : DELETE_ICON_TOP_OFFSET_PORTRAIT;

  // For the right panel in a split-panel view, shift left past the canvas midpoint
  let left: number;
  if (isLandscape) {
    left = landscapeLeftOffset;
  } else if (isRightPanel) {
    left = canvasWidth / canvasZoom + portraitLeftOffset;
  } else {
    left = portraitLeftOffset;
  }

  return { width, height, top, left };
};
